import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../i18n";
import { IMAGES } from "../data";

const EASE = [0.22, 1, 0.36, 1];

export default function Experiences() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const e = t.experiences;

  return (
    <section id="esperienze" data-testid="experiences-section" className="bg-navy py-28 text-white sm:py-36 lg:py-44">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-120px" }}
          transition={{ duration: 1, ease: EASE }}
          className="flex flex-wrap items-end justify-between gap-8"
        >
          <div className="max-w-2xl">
            <p className="kicker text-sky">
              <span className="h-px w-10 bg-sky" />
              {e.tag}
            </p>
            <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
              {e.title}
            </h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-white/65 sm:text-lg">{e.sub}</p>
          </div>
          <button
            data-testid="experiences-view-all"
            onClick={() => navigate("/esperienze")}
            className="group inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.18em] text-white transition-colors hover:text-sky"
          >
            {e.cta}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
          </button>
        </motion.div>

        <div className="mt-16 grid gap-8 sm:grid-cols-2 lg:mt-20 lg:grid-cols-3">
          {e.items.map((item, i) => (
            <motion.article
              key={item.title}
              data-testid={`experience-card-${i}`}
              onClick={() => navigate("/esperienze")}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 1, delay: i * 0.15, ease: EASE }}
              className="group cursor-pointer overflow-hidden rounded-[2rem] bg-med/40 ring-1 ring-white/10 transition-[transform,box-shadow,background-color] duration-500 hover:-translate-y-2 hover:bg-med/60 hover:shadow-[0_30px_60px_-20px_rgba(0,0,0,0.5)]"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={IMAGES.experiences[i]}
                  alt={item.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.07]"
                />
                <span className="absolute bottom-4 left-4 rounded-full bg-sky px-4 py-1.5 text-xs font-extrabold text-navy shadow-lg">
                  {e.from} {item.price} <span className="font-semibold opacity-80">{e.person}</span>
                </span>
              </div>
              <div className="p-8">
                <h3 className="font-display text-2xl font-semibold leading-snug">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-white/60">{item.text}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
